import { useState, useEffect } from 'react';
import { Icon } from 'semantic-ui-react';
import { useGetBulkVTOCountMutation, useBulkDeleteClothingMutation } from '../../redux/apis/endpoints/closetApi';
import ConfirmModal from '../common/ConfirmModal';

const BulkDeleteModal = ({ 
  isOpen, 
  onClose, 
  selectedIds = [], 
  onDeleteSuccess 
}) => {
  const [vtoCount, setVtoCount] = useState(null);
  const [isLoadingCount, setIsLoadingCount] = useState(false);
  
  const [getBulkVTOCount] = useGetBulkVTOCountMutation();
  const [bulkDeleteClothing, { isLoading: isDeleting }] = useBulkDeleteClothingMutation();

  // Fetch VTO count when modal opens
  useEffect(() => {
    if (isOpen && selectedIds.length > 0) {
      setIsLoadingCount(true);
      getBulkVTOCount(selectedIds)
        .unwrap()
        .then(result => {
          setVtoCount(result.totalVTOCount);
        })
        .catch(err => {
          console.error('Error fetching VTO count:', err);
          setVtoCount(0);
        })
        .finally(() => {
          setIsLoadingCount(false);
        });
    }
  }, [isOpen, selectedIds, getBulkVTOCount]);

  const handleDelete = async () => {
    try {
      const result = await bulkDeleteClothing(selectedIds).unwrap();
      console.log('Bulk delete successful:', result);
      onDeleteSuccess?.(result);
      onClose();
    } catch (error) {
      console.error('Bulk delete failed:', error);
    }
  };

  const itemCount = selectedIds.length;
  const hasVTOResults = vtoCount > 0;

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleDelete}
      title={`Delete ${itemCount} Item${itemCount !== 1 ? 's' : ''}`}
      titleIconName="trash"
      titleIconColor="red"
      confirmText={`Delete ${itemCount} Item${itemCount !== 1 ? 's' : ''}`}
      cancelText="Cancel"
      variant="danger"
      isLoading={isDeleting}
      loadingText="Deleting items..."
      confirmDisabled={isLoadingCount || isDeleting}
      closeOnOverlay={!isDeleting}
    >
      {isLoadingCount ? (
        <div style={{ textAlign: 'center', padding: '12px 0' }}>
          <div style={{ 
            width: 24, height: 24, margin: '0 auto 10px',
            border: '3px solid #e5e7eb', borderTopColor: '#00b5ad',
            borderRadius: '50%', animation: 'confirmSpin 0.7s linear infinite'
          }} />
          <p style={{ color: '#9ca3af', fontSize: 13 }}>Checking for associated try-on results...</p>
        </div>
      ) : (
        <>
          <p>
            Are you sure you want to delete {itemCount} clothing item{itemCount !== 1 ? 's' : ''}?
          </p>
          
          {hasVTOResults && (
            <div className="confirm-modal-warning">
              <Icon name="warning sign" color="orange" style={{ margin: 0, flexShrink: 0 }} />
              <span>
                This will also delete <strong>{vtoCount}</strong> associated virtual try-on result{vtoCount !== 1 ? 's' : ''}.
              </span>
            </div>
          )}
          
          <p className="confirm-modal-note">This action cannot be undone.</p>
        </>
      )}
    </ConfirmModal>
  );
};

export default BulkDeleteModal;
